<template>
  <div></div>
</template>

<script>
export default {
  customReadyNotify: true,
  created () {
    this.$bus.$emit('ready')
    this.download()
  },
  methods: {
    callAppBySchema (schema) {
      return new Promise((resolve, reject) => {
        let node = document.createElement('a')
        const body = document.body
        node.style.display = 'none'

        let clear = function (evt, isTimeout) {
          node.onload = null
          body.removeChild(node)
          node = null
        }

        node.onload = clear
        node.href = schema
        body.appendChild(node)
        node.click()
        let now = Date.now()

        setTimeout(() => {
          let newTime = Date.now()

          if (newTime - now > 1100) {
            resolve(true)
          } else {
            resolve(false)
          }
          clear()
        }, 1000)
      })
    },
    download () {
      const androidScheme = `ndtmd://tmd.ndmicro.com?redirectUrl=${location.origin}/river/diversion?from=LANDING_RIVER`
      const iOSScheme = `tianmeiqianbao://tmd.ndmicro.com?redirectUrl=${location.origin}/river/diversion?from=LANDING_RIVER`

      const userAgent = navigator.userAgent
      const isAndroid =
        userAgent.indexOf('Android') > -1 ||
        userAgent.indexOf('Adr') > -1 // android终端
      const isiOS = !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
      const isIpad = userAgent.indexOf('iPad') > -1
      if (isAndroid) {
        // 安卓
        // 浏览器打开
        this.callAppBySchema(androidScheme).then((res) => {
          if (!res) {
            if (
              document.webkitHidden ||
              document.hidden ||
              document.msHidden ||
              document.mozHidden
            ) {
              // 隐藏
              return false
            }
            window.location = '/river/diversion?from=LANDING_RIVER'
          }
        })
      } else if (isiOS || isIpad) {
        // IOS
        // 浏览器打开
        this.callAppBySchema(iOSScheme).then((res) => {
          if (!res) {
            if (
              document.webkitHidden ||
              document.hidden ||
              document.msHidden ||
              document.mozHidden
            ) {
              // 隐藏
              return false
            }
            window.location = '/river/diversion?from=LANDING_RIVER'
          }
        })
      }
    }
  }
}
</script>